import { createActions } from '../../../context';
import * as actions from './consumer-details.action';

export const consumerDetails = store => ({
    consumer: {
        consumerId: '',
        name: '',
        apiKey: '',
        consumerConfigData: [],
    },
    courseId: null,
    courseConfig: null,
    classGroups: [],
    courses: [],
    actions: createActions(actions)(store)
});